import React, { useState, useEffect } from "react";
import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import "../../../components/DataTable.css";
import AddEditRole from "./AddEditRole";

function Roles() {
  const [roles, setRoles] = useState([]);
  const [loading, setloading] = useState([]);
  const [displayModal, setDisplayModal] = useState(false);
  const [editable, setEditable] = useState(false);
  const [roleRowData, setroleRowData] = useState(null);
  const [setPosition] = useState("center");
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  let history = useHistory();
  const editHandler = (rowData) => {
    setDisplayModal(true);
    setroleRowData(rowData);
    setEditable(true);
  };
  const actionTemplate = (rowData) => {
    return (
      <div>
        <Button
          tooltip="Edit"
          icon="pi pi-pencil"
          tooltipOptions={{ position: "top" }}
          onClick={() => editHandler(rowData)}
          className="p-button-rounded p-button-secondary p-mr-2"
        />
        <Button
          tooltip="View Details"
          icon="pi pi-eye"
          tooltipOptions={{ position: "top" }}
          onClick={() => history.push(`/getrolerights/${rowData?.roleId}`)}
          className="p-button-rounded p-button-warning p-mr-2"
        />
      </div>
    );
  };
  const getRoles = async () => {
    setloading(true);
    const response = await handleGetRequest("zbizgateway/nonFin/getAllRole");
    setRoles(response?.data);
    setloading(false);
  };

  useEffect(() => {
    getRoles();
  }, []);

  const dialogFuncMap = {
    displayModal: setDisplayModal,
  };

  const onClick = (name, position) => {
    dialogFuncMap[`${name}`](true);

    if (position) {
      setPosition(position);
    }
  };

  const onHide = (name) => {
    setDisplayModal(false);
    setroleRowData(null);
  };
  return (
    <div>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">Roles</h3>
          </div>
          <Button
            label="Add New"
            className="Add_New"
            onClick={() => onClick("displayModal", setEditable(false))}
          />
        </div>
      </div>
      <Dialog
        header={editable ? "Edit Role" : "Add Role"}
        visible={displayModal}
        style={{ width: "50vw" }}
        onHide={() => onHide("displayModal")}
      >
        <AddEditRole
          onHide={onHide}
          editable={editable}
          roleRowData={roleRowData}
          getRoles={getRoles}
        />
      </Dialog>
      <div className="card p-datatable-sm">
        <DataTable
          loading={loading}
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          value={roles}
          emptyMessage="No data found."
        >
          <Column
            className="Table__Alignment"
            filter
            field="roleName"
            header="Role Name"
          />
          <Column
            className="Table__Alignment"
            filter
            field="roleCode"
            header="Role Code"
          />
          <Column
            className="Table__Alignment"
            body={actionTemplate}
            header="Action"
          />
        </DataTable>
      </div>
    </div>
  );
}

export default Roles;
